import {Component, inject, OnDestroy, signal, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {ProfileImage} from "../profile-image/profile-image";
import {UserProfileDto} from '../../dto/UserProfileDto';
import {form, FormField, maxLength, minLength, required, validate} from '@angular/forms/signals';
import {Subscription} from 'rxjs';
import {ProfileService} from '../../services/profile-service';

@Component({
  selector: 'app-edit-profile-component',
  imports: [
    FormsModule,
    ProfileImage,
    FormField
  ],
  templateUrl: './edit-profile-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './edit-profile-component.scss',
})
export class EditProfileComponent implements OnDestroy {

  error: string | undefined;

  profileModel= signal<UserProfileDto>({
    profileUuid: '',
    imageUrl: '',
    username: '',
    birthdate: '',
    about: '',
    email: ''
  })

  profileForm = form(this.profileModel, (schemaPath) => {
    required(schemaPath.username, { message: 'Юзернейм обязателен' });
    minLength(schemaPath.username, 3, { message: 'Минимум 3 символа' });
    maxLength(schemaPath.username, 100, { message: 'Максимум 100 символов' });

    validate(schemaPath.birthdate, ({ value }) => {
      const val = value();
      if (!val) {
        return { kind: 'required', message: 'Дата рождения обязательна' };
      }

      const birthDate = new Date(val);
      const today = new Date();
      const minDate = new Date('1900-01-01');

      if (birthDate > today) {
        return { kind: 'futureDate', message: 'Дата рождения должна быть в прошлом' };
      }

      if (birthDate < minDate) {
        return { kind: 'tooOld', message: 'Дата рождения не может быть раньше 1900 года' };
      }

      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      if (age < 18) {
        return { kind: 'tooYoung', message: 'Вам должно быть не менее 18 лет' };
      }

      return null;
    });
  });

  subscriptions: Subscription[] = [];

  private profileService = inject(ProfileService);

  constructor() {
    this.subscriptions.push(
      this.profileService.getCurrentProfile()
        .subscribe(result => {
          if (result.data) {
            this.profileModel.set(result.data);
          } else {
            this.error = result.error;
          }
        })
    );
  }

  saveProfile() {
    this.error = undefined;
    const currentProfile = this.profileModel();
    const dto = new UserProfileDto(currentProfile.profileUuid, currentProfile.imageUrl, currentProfile.username,
      currentProfile.birthdate, currentProfile.about, currentProfile.email);
    const subscription = this.profileService.updateCurrentProfile(dto)
      .subscribe(result => {
        if (result.data) {
          this.profileModel.set(result.data);
        } else {
          this.error = result.error;
        }
      });
    this.subscriptions.push(subscription);
  }

  maxDate(): string {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 18);
    return date.toISOString().split('T')[0];
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }
}
